import { TFormField, FormFieldType } from '@models/forms';

export function getUnderwritingActivityFormField({
  isEditing,
  underwritingActivityTypes,
  resolutionReasons,
}: {
  isEditing?: boolean;
  underwritingActivityTypes?: { label: string; value: string }[];
  resolutionReasons?: { label: string; value: string }[];
}): {
  [fieldName: string]: TFormField;
} {
  if (isEditing) {
    return {
      resolve: {
        name: 'resolve',
        fieldType: FormFieldType.CheckboxField,
        label: 'Mark as Resolved',
        defaultValue: false,
        required: false,
        gridWidth: { xs: 12 },
        sx: { '.MuiButtonBase-root': { marginLeft: '-8px' }, '.MuiTypography-root': { marginLeft: '24px' } },
        fieldConfig: {
          checkboxField: {
            fontWeight: 'normal',
          },
        },
      },
      resolutionReasonId: {
        name: 'resolutionReasonId',
        fieldType: FormFieldType.SelectField,
        label: 'Resolution Reason',
        required: ({ data }) => {
          return data;
        },
        gridWidth: { xs: 12 },
        watchedField: 'resolve',
        isVisible: ({ data }) => {
          return data?.watchedField;
        },
        fieldConfig: {
          selectField: {
            options: resolutionReasons ?? [],
          },
        },
      },
      resolutionNote: {
        name: 'resolutionNote',
        fieldType: FormFieldType.TextField,
        label: 'Optional Note',
        required: false,
        gridWidth: { xs: 12 },
        fieldConfig: {
          textField: {
            multiline: true,
            rows: 5,
          },
        },
      },
    };
  } else {
    return {
      type: {
        name: 'type',
        fieldType: FormFieldType.SelectField,
        label: 'Reason',
        required: true,
        gridWidth: { xs: 12 },
        watchedField: 'resolve',
        fieldConfig: {
          selectField: {
            options: underwritingActivityTypes ?? [],
          },
        },
      },
      description: {
        name: 'description',
        fieldType: FormFieldType.TextField,
        label: 'Description',
        required: false,
        gridWidth: { xs: 12 },
        fieldConfig: {
          textField: {
            multiline: true,
            rows: 7,
            maxLength: 500,
          },
        },
      },
    };
  }
}
